import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProfileDisplay from '../components/ProfileDisplay';
import { FiCheckSquare, FiDatabase, FiHeart, FiMessageCircle, FiArrowRight, FiUsers, FiTrendingUp, FiShield, FiStar, FiBookOpen, FiLink, FiUser, FiCamera } from 'react-icons/fi';

const Home = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 英雄區域 */}
      <div className="bg-gray-50 relative overflow-hidden">

        <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8 relative">
          <div className="text-center">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-800 text-sm font-medium mb-6">
              <FiStar className="mr-2" />
              ALPHA TEST 測試中
            </div>

            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
              <span className="block flex items-center justify-center space-x-3">
                {/* Logo SVG - 空心愛心：上半紫色M框、下半黃色V框 */}
                <div className="w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0">
                  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {/* 上半部 - 紫色M形邊框（中間向下形成M形） */}
                    <path 
                      d="M7 19C7 15.5 8.5 12.5 11 10.5C13 9 16 8.5 20 13C24 8.5 27 9 29 10.5C31.5 12.5 33 15.5 33 19C33 20.5 32.5 22 31.5 23.5" 
                      stroke="#8B5CF6" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                      fill="none"
                    />
                    {/* 下半部 - 黃色V形邊框 */}
                    <path 
                      d="M8.5 23.5C9.5 25 11 26.5 13 28C15.5 30 17.5 32 20 35C22.5 32 24.5 30 27 28C29 26.5 30.5 25 31.5 23.5" 
                      stroke="#EAB308" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                </div>
                <span>
                  <span className="text-yellow-500">Vote</span>
                  <span className="bg-gradient-to-r from-yellow-500 to-purple-500 bg-clip-text text-transparent">2</span>
                  <span className="text-purple-500">Match</span>
                </span>
              </span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 to-purple-600 mt-2">
                投票找到志同道合的朋友或伴侶
              </span>
            </h1>

            <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-600 sm:text-2xl leading-relaxed">
              告別淺層交友，透過深度投票系統發現價值觀相近的朋友或伴侶
            </p>

            <div className="mt-4 max-w-2xl mx-auto text-lg text-gray-500">
              🎯 不再只看外表，真正瞭解對方的想法和生活態度
            </div>


            <div className="mt-12 max-w-md mx-auto sm:flex sm:justify-center gap-4">
              {user ? (
                <>
                  <Link
                    to="/voting"
                    className="flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-xl text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 shadow-lg hover:shadow-xl transition-all duration-200 md:py-5 md:text-lg md:px-12"
                  >
                    <FiCheckSquare className="mr-2" />
                    開始投票
                    <FiArrowRight className="ml-2" />
                  </Link>
                  <Link
                    to="/matching"
                    className="flex items-center justify-center px-8 py-4 border-2 border-blue-600 text-base font-medium rounded-xl text-blue-600 bg-white hover:bg-blue-50 hover:border-blue-700 transition-all duration-200 md:py-5 md:text-lg md:px-12"
                  >
                    <FiHeart className="mr-2" />
                    尋找配對
                  </Link>
                </>
              ) : (
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/register"
                    className="flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-xl text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 shadow-lg hover:shadow-xl transition-all duration-200 md:py-5 md:text-lg md:px-12"
                  >
                    <FiStar className="mr-2" />
                    免費註冊開始
                    <FiArrowRight className="ml-2" />
                  </Link>
                  <div className="flex flex-col gap-4">
                    <Link
                      to="/login"
                      className="flex items-center justify-center px-8 py-4 border-2 border-gray-300 text-base font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200 md:py-5 md:text-lg md:px-12"
                    >
                      已有帳號登入
                    </Link>
                    <Link
                      to="/voting"
                      className="flex items-center justify-center px-8 py-4 border-2 border-gray-300 text-base font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200 md:py-5 md:text-lg md:px-12"
                    >
                      先逛逛
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <p className="mt-8 text-sm text-gray-500">
              ✓ 完全免費 ✓ 隱私保護 ✓ 不必須上傳照片
            </p>
          </div>
        </div>
      </div>

      {/* 核心功能介紹 */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-purple-600 font-semibold tracking-wide uppercase mb-4">使用流程</h2>
            <p className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              五步驟，開啟vote2match 之旅
            </p>
          </div>

          {/* 詳細使用流程 */}
          <div className="space-y-16">

            {/* 步驟 1: 簡單自我介紹 */}
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm">
              <div className="flex flex-col lg:flex-row items-center gap-12">
                <div className="lg:w-1/2">
                  <div className="flex items-center mb-6">
                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-indigo-600 text-white font-bold text-2xl shadow-lg">
                      1
                    </div>
                    <div className="ml-6">
                      <h3 className="text-3xl font-bold text-gray-900 mb-2">
                        簡單自我介紹
                      </h3>
                      <p className="text-lg text-indigo-600 font-medium">完成稱呼與基本介紹</p>
                    </div>
                  </div>

                  <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                    第一步很簡單，只需要完成你的稱呼和簡單的自我介紹即可。
                    自我介紹可以簡單寫就好，真正表現個人特色的是下一步，好戲在後頭！
                    你也可以選擇是否上傳照片，完全由你決定。
                  </p>

                  <div className="space-y-4">
                    <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
                          <FiUser className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-900 mb-2">基本資料</h4>
                          <p className="text-sm text-gray-600 mb-3">
                            填寫你的稱呼和簡單的自我介紹，讓大家認識你
                          </p>
                          <div className="text-sm text-gray-500 italic">
                            💡 提示：自我介紹可以簡單寫，真正的個人特色會在下一步展現
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-gray-400 rounded-full flex items-center justify-center">
                          <FiCamera className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-900 mb-2">照片上傳（選填）</h4>
                          <p className="text-sm text-gray-600">
                            你可以選擇是否上傳照片，完全由你決定。我們重視的是價值觀的契合，而非外表。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:w-1/2">
                  <div
                    onClick={() => user && navigate('/profile')}
                    className={`bg-gradient-to-br from-indigo-500 to-blue-600 rounded-2xl p-8 text-center text-white shadow-xl ${user ? 'cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300' : ''}`}
                  >
                    <FiUser className="w-16 h-16 mx-auto mb-4" />
                    <h4 className="text-2xl font-bold mb-2">完成你的個人資料</h4>
                    <p className="text-indigo-100">簡單開始，精彩在後</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 步驟 2: 探索投票 */}
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm">
              <div className="flex flex-col lg:flex-row items-center gap-12">
                <div className="lg:w-1/2">
                  <div className="flex items-center mb-6">
                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-600 text-white font-bold text-2xl shadow-lg">
                      2
                    </div>
                    <div className="ml-6">
                      <h3 className="text-3xl font-bold text-gray-900 mb-2">
                        探索 & 投票
                      </h3>
                      <p className="text-lg text-blue-600 font-medium">找到你的聲音</p>
                    </div>
                  </div>

                  <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                    在我們的投票廣場中，投票可以是各種類型：興趣愛好、流行文化、價值觀、生活態度等。
                    每一次投票都是在認識自己，也在尋找志同道合的朋友或伴侶。
                  </p>

                  <div className="space-y-6">
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                      <div className="p-3 border-b border-gray-100">
                        <h4 className="font-semibold text-gray-900 mb-2 text-base">興趣類型</h4>
                        <p className="text-sm text-gray-600 mb-2">💡 興趣類型投票 - 找到共同愛好的夥伴</p>
                        <div className="flex items-center text-xs text-gray-500">
                          <span>👤 小明</span>
                        </div>
                      </div>
                      <div className="p-3">
                        <div className="space-y-2">
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-yellow-400 border-2 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-yellow-100" style={{ width: '45%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">追番追劇</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-blue-600 text-xs">✓ 已投票</span>
                                  <span className="text-xs text-gray-700 font-medium">45 票 45.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '35%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">打球運動</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">35 票 35.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '20%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">美食逛街</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">20 票 20.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="px-3 py-2 bg-gray-50 rounded-b-lg">
                        <div className="flex items-center justify-between text-xs gap-2">
                          <button className="px-2 py-1 rounded bg-gray-100 text-gray-700 hover:bg-gray-200 transition-all text-xs font-medium whitespace-nowrap">
                            收起
                          </button>
                          <div className="flex items-center space-x-1.5 flex-shrink-0">
                            <span className="text-gray-300">|</span>
                            <span className="text-gray-600 whitespace-nowrap">🗳️ 100</span>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-yellow-100 text-yellow-700 hover:bg-yellow-200 transition-all text-xs font-medium whitespace-nowrap">
                              編輯
                            </button>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-gradient-to-r from-pink-400 to-purple-500 text-white hover:from-pink-500 hover:to-purple-600 transition-all text-xs font-medium whitespace-nowrap">
                              加入擇友標準
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                      <div className="p-3 border-b border-gray-100">
                        <h4 className="font-semibold text-gray-900 mb-2 text-base">最喜歡的鬼滅之刃角色</h4>
                        <p className="text-sm text-gray-600 mb-2">🎬 流行文化投票 - 發現同好</p>
                        <div className="flex items-center text-xs text-gray-500">
                          <span>👤 小華</span>
                        </div>
                      </div>
                      <div className="p-3">
                        <div className="space-y-2">
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '15%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">炎柱</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">12 票 15.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-yellow-400 border-2 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-yellow-100" style={{ width: '40%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">猗窩座</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-blue-600 text-xs">✓ 已投票</span>
                                  <span className="text-xs text-gray-700 font-medium">32 票 40.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '35%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">炭治郎</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">28 票 35.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '10%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">無慘</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">8 票 10.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="px-3 py-2 bg-gray-50 rounded-b-lg">
                        <div className="flex items-center justify-between text-xs gap-2">
                          <button className="px-2 py-1 rounded bg-gray-100 text-gray-700 hover:bg-gray-200 transition-all text-xs font-medium whitespace-nowrap">
                            收起
                          </button>
                          <div className="flex items-center space-x-1.5 flex-shrink-0">
                            <span className="text-gray-300">|</span>
                            <span className="text-gray-600 whitespace-nowrap">🗳️ 80</span>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-yellow-100 text-yellow-700 hover:bg-yellow-200 transition-all text-xs font-medium whitespace-nowrap">
                              編輯
                            </button>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-gradient-to-r from-pink-400 to-purple-500 text-white hover:from-pink-500 hover:to-purple-600 transition-all text-xs font-medium whitespace-nowrap">
                              加入擇友標準
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                      <div className="p-3 border-b border-gray-100">
                        <h4 className="font-semibold text-gray-900 mb-2 text-base">最捨得花錢的事物</h4>
                        <p className="text-sm text-gray-600 mb-2">💰 消費價值觀投票 - 瞭解生活態度</p>
                        <div className="flex items-center text-xs text-gray-500">
                          <span>👤 小雅</span>
                        </div>
                      </div>
                      <div className="p-3">
                        <div className="space-y-2">
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '25%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">演唱會與偶像周邊</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">18 票 25.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-yellow-400 border-2 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-yellow-100" style={{ width: '42%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">喫美食旅遊</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-blue-600 text-xs">✓ 已投票</span>
                                  <span className="text-xs text-gray-700 font-medium">30 票 42.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '20%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">買車租房</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">14 票 20.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '13%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">遊戲與電腦</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">9 票 13.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="px-3 py-2 bg-gray-50 rounded-b-lg">
                        <div className="flex items-center justify-between text-xs gap-2">
                          <button className="px-2 py-1 rounded bg-gray-100 text-gray-700 hover:bg-gray-200 transition-all text-xs font-medium whitespace-nowrap">
                            收起
                          </button>
                          <div className="flex items-center space-x-1.5 flex-shrink-0">
                            <span className="text-gray-300">|</span>
                            <span className="text-gray-600 whitespace-nowrap">🗳️ 71</span>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-yellow-100 text-yellow-700 hover:bg-yellow-200 transition-all text-xs font-medium whitespace-nowrap">
                              編輯
                            </button>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-gradient-to-r from-pink-400 to-purple-500 text-white hover:from-pink-500 hover:to-purple-600 transition-all text-xs font-medium whitespace-nowrap">
                              加入擇友標準
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                      <div className="p-3 border-b border-gray-100">
                        <h4 className="font-semibold text-gray-900 mb-2 text-base">你是</h4>
                        <p className="text-sm text-gray-600 mb-2">👤 性別身份 - 可作為配對參考</p>
                        <div className="flex items-center text-xs text-gray-500">
                          <span>👤 大雄</span>
                        </div>
                      </div>
                      <div className="p-3">
                        <div className="space-y-2">
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-yellow-400 border-2 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-yellow-100" style={{ width: '48%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">男生</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-blue-600 text-xs">✓ 已投票</span>
                                  <span className="text-xs text-gray-700 font-medium">48 票 48.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div className="relative overflow-hidden">
                            <button className="w-full p-3 text-left rounded-lg border border-gray-200 transition-all duration-200 relative">
                              <div className="absolute inset-0 bg-gray-100" style={{ width: '52%' }}></div>
                              <div className="flex items-center justify-between relative z-10">
                                <span className="font-medium text-sm flex-1 mr-2 truncate">女生</span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <span className="text-xs text-gray-700 font-medium">52 票 52.00%</span>
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="px-3 py-2 bg-gray-50 rounded-b-lg">
                        <div className="flex items-center justify-between text-xs gap-2">
                          <button className="px-2 py-1 rounded bg-gray-100 text-gray-700 hover:bg-gray-200 transition-all text-xs font-medium whitespace-nowrap">
                            收起
                          </button>
                          <div className="flex items-center space-x-1.5 flex-shrink-0">
                            <span className="text-gray-300">|</span>
                            <span className="text-gray-600 whitespace-nowrap">🗳️ 100</span>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-yellow-100 text-yellow-700 hover:bg-yellow-200 transition-all text-xs font-medium whitespace-nowrap">
                              編輯
                            </button>
                            <span className="text-gray-300">|</span>
                            <button className="px-2 py-1 rounded bg-gradient-to-r from-pink-400 to-purple-500 text-white hover:from-pink-500 hover:to-purple-600 transition-all text-xs font-medium whitespace-nowrap">
                              加入擇友標準
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:w-1/2">
                  <div
                    onClick={() => navigate('/voting')}
                    className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl p-8 text-center text-white shadow-xl cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300"
                  >
                    <FiCheckSquare className="w-16 h-16 mx-auto mb-4" />
                    <h4 className="text-2xl font-bold mb-2">開始你的投票之旅</h4>
                    <p className="text-blue-100">每票都是在定義真實的你</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 步驟 3: 打造題庫 */}
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-3xl p-8 md:p-12">
              <div className="flex flex-col lg:flex-row-reverse items-center gap-12">
                <div className="lg:w-1/2">
                  <div className="flex items-center mb-6">
                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-purple-600 text-white font-bold text-2xl shadow-lg">
                      3
                    </div>
                    <div className="ml-6">
                      <h3 className="text-3xl font-bold text-gray-900 mb-2">
                        打造專屬題庫
                      </h3>
                      <p className="text-lg text-purple-600 font-medium">設定你的擇友標準</p>
                    </div>
                  </div>

                  <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                    將你最重視的話題加入個人題庫，自訂每個問題在配對中的重要性。
                    這就是你的「擇友DNA」。
                  </p>

                  <div className="space-y-6">
                    <div className="p-4 sm:p-6 overflow-hidden rounded-lg bg-white border border-gray-200 shadow hover:shadow-md transition-shadow">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-lg font-bold text-gray-900">興趣類型</span>
                        <button className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors">
                          編輯
                        </button>
                      </div>
                      <div className="text-gray-700 mb-2">追番追劇｜打球運動｜美食逛街</div>
                      <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                        <span>權重: 1</span>
                        <span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs">必答題</span>
                      </div>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center text-sm">
                          <span>1. 追番追劇</span>
                          <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-bold">+10.00分</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>2. 打球運動</span>
                          <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-bold">+7.00分</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>3. 美食逛街</span>
                          <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-bold">+5.00分</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>4. 不喜歡以上活動</span>
                          <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs font-bold">-3.00分</span>
                        </div>
                      </div>
                    </div>

                    <div className="p-4 sm:p-6 overflow-hidden rounded-lg bg-white border border-gray-200 shadow hover:shadow-md transition-shadow">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-lg font-bold text-gray-900">最喜歡的鬼滅之刃角色</span>
                        <button className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors">
                          編輯
                        </button>
                      </div>
                      <div className="text-gray-700 mb-2">炎柱｜猗窩座｜炭治郎｜無慘</div>
                      <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                        <span>權重: 4</span>
                        <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs">高重要</span>
                      </div>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center text-sm">
                          <span>1. 炎柱</span>
                          <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-bold">+8.00分</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>2. 猗窩座</span>
                          <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-bold">+10.00分</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>3. 炭治郎</span>
                          <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-bold">+6.00分</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>4. 無慘</span>
                          <span className="bg-red-100 text-gray-600 px-2 py-1 rounded text-xs font-bold">-9999分</span>
                        </div>
                      </div>
                    </div>


                    <div className="p-4 sm:p-6 overflow-hidden rounded-lg bg-white border border-gray-200 shadow hover:shadow-md transition-shadow">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-lg font-bold text-gray-900">你是</span>
                        <button className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors">
                          編輯
                        </button>
                      </div>
                      <div className="text-gray-700 mb-2">男生｜女生</div>
                      <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                        <span>權重: 8</span>
                        <span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs">必答題</span>
                      </div>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center text-sm">
                          <span>1. 男生</span>
                          <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs font-bold">-10.00分</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>2. 女生</span>
                          <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-bold">+10.00分</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="lg:w-1/2">
                  <div
                    onClick={() => user && navigate('/voting?tab=questions')}
                    className={`bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl p-8 text-center text-white shadow-xl ${user ? 'cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300' : ''}`}
                  >
                    <FiDatabase className="w-16 h-16 mx-auto mb-4" />
                    <h4 className="text-2xl font-bold mb-2">建立你的價值觀地圖</h4>
                    <p className="text-purple-100">精準定義你想要的關係</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 步驟 4: 智能配對 */}
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm">
              <div className="flex flex-col lg:flex-row items-center gap-12">
                <div className="lg:w-1/2">
                    <div className="flex items-center mb-6">
                      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-pink-600 text-white font-bold text-2xl shadow-lg">
                        4
                      </div>
                      <div className="ml-6">
                        <h3 className="text-3xl font-bold text-gray-900 mb-2">
                          智能配對
                        </h3>
                        <p className="text-lg text-pink-600 font-medium">基於你的擇友標準配對</p>
                      </div>
                    </div>

                    <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                      系統會根據你第三步建立的擇友標準，
                      推薦符合你價值觀的理想朋友或伴侶。
                    </p>

                  <div className="bg-white rounded-xl p-6 shadow-lg">
                    <div className="flex items-center justify-between mb-6">
                      <div>
                        <h4 className="text-lg font-bold text-gray-900">配對分析</h4>
                        <p className="text-sm text-gray-600">與「小雅」的匹配分析</p>
                      </div>
                    </div>

                    {/* 分數詳情 */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <div className="bg-gray-50 rounded-lg p-4">
                        <div className="text-sm text-gray-600">得分</div>
                        <div className="text-xl font-semibold text-purple-600">9.42</div>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-4">
                        <div className="text-sm text-gray-600">總權重</div>
                        <div className="text-xl font-semibold text-purple-600">13</div>
                      </div>
                    </div>

                    {/* 對方的回答 */}
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="text-lg font-semibold text-gray-900">對方的回答</h4>
                        <button className="flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors">
                          <span className="mr-1">收起</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                          </svg>
                        </button>
                      </div>
                      <div className="space-y-2 max-h-96 overflow-y-auto">
                        <div className="bg-gray-50 rounded-lg p-3">
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-base font-medium text-gray-700 break-words">興趣類型</span>
                            <span className="text-sm font-semibold whitespace-nowrap ml-2 flex-shrink-0 text-purple-600">
                              匹配
                            </span>
                          </div>
                          <div className="text-sm text-purple-600 mb-2 break-words">
                            回答: 追番追劇
                          </div>
                          <div className="text-sm text-gray-500">
                            權重: 1 | 得分: <span>2.50</span>
                          </div>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-3">
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-base font-medium text-gray-700 break-words">最喜歡的鬼滅之刃角色</span>
                            <span className="text-sm font-semibold whitespace-nowrap ml-2 flex-shrink-0 text-purple-600">
                              匹配
                            </span>
                          </div>
                          <div className="text-sm text-purple-600 mb-2 break-words">
                            回答: 猗窩座
                          </div>
                          <div className="text-sm text-gray-500">
                            權重: 4 | 得分: <span>10.00</span>
                          </div>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-3">
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-base font-medium text-gray-700 break-words">你是</span>
                            <span className="text-sm font-semibold whitespace-nowrap ml-2 flex-shrink-0 text-purple-600">
                              匹配
                            </span>
                          </div>
                          <div className="text-sm text-purple-600 mb-2 break-words">
                            回答: 女生
                          </div>
                          <div className="text-sm text-gray-500">
                            權重: 8 | 得分: <span>10.00</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 p-3 bg-pink-50 rounded-lg">
                      <p className="text-sm text-pink-800">
                        <strong>匹配分析：</strong>你們在覈心價值觀上高度一致，生活節奏相近。
                        這是一個值得深入瞭解的人！建議發送配對邀請。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="lg:w-1/2">
                  <div
                    onClick={() => user && navigate('/matching')}
                    className={`bg-gradient-to-br from-pink-500 to-red-600 rounded-2xl p-8 text-center text-white shadow-xl ${user ? 'cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300' : ''}`}
                  >
                    <FiHeart className="w-16 h-16 mx-auto mb-4" />
                    <h4 className="text-2xl font-bold mb-2">發現志同道合的朋友或伴侶</h4>
                    <p className="text-pink-100">讓數據說話，找到契合的關係</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 步驟 5: 話題驅動對話 */}
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm">
              <div className="flex flex-col lg:flex-row-reverse items-center gap-12">
                <div className="lg:w-1/2">
                  <div className="flex items-center mb-6">
                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-green-600 text-white font-bold text-2xl shadow-lg">
                      5
                    </div>
                    <div className="ml-6">
                      <h3 className="text-3xl font-bold text-gray-900 mb-2">
                        話題驅動對話
                      </h3>
                      <p className="text-lg text-green-600 font-medium">永遠不會無話可說</p>
                    </div>
                  </div>

                  <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                    成為好友後，系統會自動整理你們共同投票過的話題，
                    提供源源不絕的聊天靈感和深度討論點。
                  </p>

                  <div className="bg-white rounded-xl p-6 shadow-lg">
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-bold text-gray-900">與小雅的共同觀點</h4>
                      <div className="text-sm text-green-600 font-medium">5個話題可聊</div>
                    </div>

                    <div className="space-y-3">
                      <div className="py-2 border-b border-gray-100">
                        <div className="text-sm text-gray-900 font-medium mb-1">共同喜歡的歌手</div>
                        <div className="text-sm text-green-600">一致：tuki.</div>
                      </div>

                      <div className="py-2 border-b border-gray-100">
                        <div className="text-sm text-gray-900 font-medium mb-1">共同的運動興趣</div>
                        <div className="text-sm text-green-600">一致：羽毛球</div>
                      </div>

                      <div className="py-2 border-b border-gray-100">
                        <div className="text-sm text-gray-900 font-medium mb-1">共同的旅行夢想</div>
                        <div className="text-sm text-blue-600">相近：京都</div>
                      </div>

                      <div className="py-2 border-b border-gray-100">
                        <div className="text-sm text-gray-900 font-medium mb-1">共同的書籍喜好</div>
                        <div className="text-sm text-green-600">一致：村上春樹</div>
                      </div>

                      <div className="py-2">
                        <div className="text-sm text-gray-900 font-medium mb-1">共同的咖啡偏好</div>
                        <div className="text-sm text-blue-600">相近：手沖咖啡</div>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-t border-gray-200">
                      <div className="text-sm text-gray-600 text-center">
                        💡 點擊查看投票詳情
                      </div>
                    </div>

                    <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                      <div className="text-sm text-gray-700 mb-2">
                        <strong>💡 建議的開場話題：</strong>
                      </div>
                      <div className="text-sm text-gray-600">
                        「我發現我們都喜歡追番，你最喜歡的動漫是什麼呀？最近有什麼新作推薦嗎？」
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:w-1/2">
                  <div
                    onClick={() => user && navigate('/friends')}
                    className={`bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl p-8 text-center text-white shadow-xl ${user ? 'cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300' : ''}`}
                  >
                    <FiMessageCircle className="w-16 h-16 mx-auto mb-4" />
                    <h4 className="text-2xl font-bold mb-2">展開有意義的對話</h4>
                    <p className="text-green-100">從價值觀開始，建立真摯的關係</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 更多功能等你發現 */}
            <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-3xl p-8 md:p-12 shadow-sm">
              <div className="flex flex-col lg:flex-row items-center gap-12">
                <div className="lg:w-1/2">
                  <div className="mb-6">
                    <h3 className="text-3xl font-bold text-gray-900 mb-2">
                      更多功能等你發現
                    </h3>
                    <p className="text-lg text-indigo-600 font-medium">探索無限可能</p>
                  </div>

                  <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                    除了核心功能，我們還提供許多實用工具幫助你更有效率地找到理想朋友或伴侶。
                  </p>

                  <div className="space-y-4">
                    {/* 投票攻略 */}
                    <div 
                      onClick={() => user && navigate('/voting?viewMode=strategy')}
                      className={`bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-200 ${user ? 'cursor-pointer hover:scale-105' : ''}`}
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
                          <FiBookOpen className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-lg font-bold text-gray-900 mb-2">投票攻略</h4>
                          <p className="text-sm text-gray-600 mb-3">
                            系統會根據你喜歡的使用者，推薦他們擇友標準中的投票話題。
                            參與這些投票可以提升你們的配對分數！
                          </p>
                          {user ? (
                            <button className="text-sm text-purple-600 font-medium hover:text-purple-700 transition-colors">
                              查看投票攻略 →
                            </button>
                          ) : (
                            <span className="text-sm text-gray-400">登入後即可使用</span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* 取得測試連結 */}
                    <div 
                      onClick={() => user && navigate('/tests')}
                      className={`bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-200 ${user ? 'cursor-pointer hover:scale-105' : ''}`}
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
                          <FiLink className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-lg font-bold text-gray-900 mb-2">🔗 取得測試連結</h4>
                          <p className="text-sm text-gray-600 mb-3">
                            創建你的擇友標準後，可以取得測試連結分享給他人。
                            讓你快速了解對方
                          </p>
                          {user ? (
                            <button className="text-sm text-blue-600 font-medium hover:text-blue-700 transition-colors">
                              前往測試管理 →
                            </button>
                          ) : (
                            <span className="text-sm text-gray-400">登入後即可使用</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:w-1/2">
                  <div
                    onClick={() => user && navigate('/voting?viewMode=strategy')}
                    className={`bg-gradient-to-br from-indigo-500 to-blue-600 rounded-2xl p-8 text-center text-white shadow-xl ${user ? 'cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300' : ''}`}
                  >
                    <FiBookOpen className="w-16 h-16 mx-auto mb-4" />
                    <h4 className="text-2xl font-bold mb-2">探索更多功能</h4>
                    <p className="text-indigo-100">發現平台的無限可能</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 為什麼選擇我們 */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
              重新定義交友體驗
            </h2>
            <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
              告別淺層滑動，開啟深度連結的新時代
            </p>
          </div>

          {/* 特色功能展示 */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <FiShield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">真實價值觀</h3>
              <p className="text-gray-600 leading-relaxed">
                不再只看外表和簡介，透過深度投票瞭解對方的真實想法、生活態度與人生觀。
                每一次互動都是在探索真實的靈魂。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center mb-6">
                <FiTrendingUp className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">精準價值配對</h3>
              <p className="text-gray-600 leading-relaxed">
                根據投票答案計算價值觀相似度，讓你提前瞭解雙方契合度。
                讓每一次認識都建立在堅實的基礎上。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                <FiUsers className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">永無止盡話題</h3>
              <p className="text-gray-600 leading-relaxed">
                系統自動整理共同投票話題，提供源源不絕的聊天素材。
                從價值觀討論開始，發展出真摯的友誼或情感連結。
              </p>
            </div>
          </div>

          {/* 對比表格 */}
          <div className="bg-gray-50 rounded-3xl shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-2">
              {/* 傳統方式 */}
              <div className="bg-white p-8 md:p-12">
                <div className="text-center mb-8">
                  <div className="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-3xl">📱</span>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-400">傳統交友軟體</h3>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-red-500 text-sm">✗</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">淺層認識</h4>
                      <p className="text-gray-600 text-sm mt-1">只看照片和簡短介紹，無法深入瞭解</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-red-500 text-sm">✗</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">隨機配對</h4>
                      <p className="text-gray-600 text-sm mt-1">算法僅考慮距離和喜好，缺乏深度分析</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-red-500 text-sm">✗</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">無話可聊</h4>
                      <p className="text-gray-600 text-sm mt-1">見面後才發現興趣不合，話題匱乏</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-red-500 text-sm">✗</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">價值觀衝突</h4>
                      <p className="text-gray-600 text-sm mt-1">認識一段時間後才發現理念差異太大</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Vote2Match */}
              <div className="bg-gray-50 p-8 md:p-12">
                <div className="text-center mb-8">
                  {/* Logo SVG - 空心愛心：上半紫色M框、下半黃色V框 */}
                  <div className="w-20 h-20 mx-auto mb-4">
                    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {/* 上半部 - 紫色M形邊框（中間向下形成M形） */}
                      <path 
                        d="M7 19C7 15.5 8.5 12.5 11 10.5C13 9 16 8.5 20 13C24 8.5 27 9 29 10.5C31.5 12.5 33 15.5 33 19C33 20.5 32.5 22 31.5 23.5" 
                        stroke="#8B5CF6" 
                        strokeWidth="2.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        fill="none"
                      />
                      {/* 下半部 - 黃色V形邊框 */}
                      <path 
                        d="M8.5 23.5C9.5 25 11 26.5 13 28C15.5 30 17.5 32 20 35C22.5 32 24.5 30 27 28C29 26.5 30.5 25 31.5 23.5" 
                        stroke="#EAB308" 
                        strokeWidth="2.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        fill="none"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold">
                    <span className="text-yellow-500">Vote</span>
                    <span className="bg-gradient-to-r from-yellow-500 to-purple-500 bg-clip-text text-transparent">2</span>
                    <span className="text-purple-500">Match</span>
                  </h3>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-green-500 text-sm">✓</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">深度認識</h4>
                      <p className="text-gray-700 text-sm mt-1">透過投票瞭解對方的真實價值觀和生活態度</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-green-500 text-sm">✓</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">智能配對</h4>
                      <p className="text-gray-700 text-sm mt-1">分析價值觀相似度，預知配對契合度</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-green-500 text-sm">✓</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">話題無限</h4>
                      <p className="text-gray-700 text-sm mt-1">系統自動提供共同話題，聊天自然流暢</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mt-1">
                      <span className="text-green-500 text-sm">✓</span>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">價值觀和諧</h4>
                      <p className="text-gray-700 text-sm mt-1">配對前就知道理念是否相近，減少衝突</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
  );
};

export default Home; 